import produce from 'immer';
import { MISSING_DATA_ACTIONS } from './actions';

const initialState = {
  records: [],
  loading: false,
  type: '',
};

const MissingData = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case MISSING_DATA_ACTIONS.GET_MISSING_DATA:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = type;
      });
    case MISSING_DATA_ACTIONS.GET_MISSING_DATA_SUCCESS:
      return produce(state, (draft) => {
        draft.records = payload;
        draft.loading = false;
        draft.type = type;
      });
    case MISSING_DATA_ACTIONS.GET_MISSING_DATA_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = type;
      });
    default:
      return state;
  }
};

export default MissingData;
